import defaultStyles from "./defaultStyles.module.scss";
import cn from "clsx";

interface SelectProps {
  isFullWidth?: boolean;
  value: string;
  onChangeFunc: (value: string) => void;
  options: string[];
  disabled?: boolean;
  onBlur?: () => void;
  isDark?: boolean;
  id: string;
  customStyles?: { [key: string]: string };
  isProgramListPage?: boolean;
}

export default function SelectDark({
  isFullWidth = true,
  value,
  onChangeFunc,
  options,
  disabled = false,
  onBlur,
  isDark = true,
  id = "select_dark",
  customStyles,
  isProgramListPage = false,
}: SelectProps) {
  const styles = customStyles || defaultStyles;
  return (
    <div
      className={cn(styles.SelectContainer, {
        "w-full": isFullWidth,
        [styles.SelectContainerProgramListPage]: isProgramListPage,
      })}
    >
      <select
        className={cn({
          [styles.Select__Field_Dark]: isDark,
          [styles.SelectContainerProgramListPage]: isProgramListPage,
        })}
        value={value}
        onChange={(e) => onChangeFunc(e.target.value)}
        disabled={disabled}
        onBlur={onBlur}
        id={id}
      >
        {options.map((option, i) => (
          <option value={option} key={i}>
            {option}
          </option>
        ))}
      </select>
      <div className={styles.Select__Arrow}>
        <svg
          width="13"
          height="9"
          viewBox="0 0 13 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 1L6.62222 7L0.999999 1"
            stroke="#fff"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
}
